import seon from '@seontechnologies/seon-javascript-sdk';

export async function getSeonSessionID(): Promise<string> {
  try {
    seon.init();

    const sessionId = await seon.getSession();
    if (!sessionId) {
      throw new Error('Seon session RUT is empty or undefined');
    }

    return sessionId;
  } catch (error) {
    return '';
  }
}
